import React, { useEffect, useState } from "react";
import AuthService from "../services/auth/auth_service";
import { FaHome, FaUser, FaCalendar } from "react-icons/fa";
import Tooltip from "@material-tailwind/react";
import Category1 from "./category1";

export default function Category({ subCategory0, categoryOg, activeTabValue }) {








     const [subCategory, setSubCategory] = useState([]);
     const [subCategoryName, setSubCategoryName] = useState('All');
      const [subCategoryId, setSubCategoryId] = useState(1);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(1);

 /* useEffect(() => {
    // Load products for the specified category when the component mounts
    AuthService.loadAllProducts(categoryOg)
      .then((response) => {
           const formattedSubCategory = response.data.results.map((product) => ({
          ...product,
          price: product.price.toLocaleString(),
        }));
        setSubCategory(formattedSubCategory);
        /!*setSubCategory(response.data.results);*!/
        setLoading(false);

      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
  }, [categoryOg]);*/

  const handleClick = (name, id) => {

      setSubCategoryName(name)


  };



/*useEffect(() => {
    // Use the 'category' prop as the default category
    const defaultCategory = category;

    // Load products for the specified category when the component mounts
    AuthService.loadAllProducts({ category: defaultCategory })
      .then((response) => {
        setSubCategory(response.data.results);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
  }, [category]); */



    /* const [scrollPosition, setScrollPosition] = useState(0);

  // Save scroll position when the component unmounts
  useEffect(() => {
    return () => {
      setScrollPosition(window.scrollY);
    };
  }, []);*/

  // Restore scroll position when the component mounts

 /* useEffect(() => {
    setTimeout(()=>{
        window.scrollTo(0, sessionStorage.getItem('scroll'));
    },[3000])
  }, []);*/

  return (
   <>

     {/*  <span style={{float:"right"}}>{categoryOg}</span>*/}
     <div style={{marginTop:'-20px'}} className="flex items-center justify-center">

        {/*{subCategory0.map((d, i) => {
  const isActive = d.id === activeTab; // Assuming activeTab is the currently active tab ID

  return (
    <div key={d.id} className={`border-b ${isActive ? 'border-blue-600' : 'border-gray-200 dark:border-gray-700'}`}>
      <nav
        className="-mb-0.5 flex justify-end space-x-6"
        aria-label="Tabs"
        role="tablist"
      >
        <button
          onClick={() => handleClick(d.name)}
          type="button"
          className={`
            ${
              isActive
                ? 'font-semibold border-b-2 border-blue-600 text-blue-600'
                : 'text-gray-500 hover:text-blue-600'
            } 
            py-2 px-4 inline-flex items-center gap-2 border-transparent text-sm whitespace-nowrap transition-all duration-300 ease-in-out transform ${
              isActive ? 'scale-105' : ''
            }
          `}
          id={`horizontal-right-alignment-item-${d.id}`}
          data-hs-tab={`#horizontal-right-alignment-${d.id}`}
          aria-controls={`horizontal-right-alignment-${d.id}`}
          role="tab"
        >
           Icon
          {isActive ? (
            <span className={`mr-1 text-lg ${d.icon}`} /> // Active icon
          ) : (
            <span className={`mr-1 text-lg text-gray-400 hover:text-blue-600 ${d.icon}`} /> // Inactive icon
          )}
           Tab label
          {d.name}
        </button>

      </nav>
    </div>
  );
})}
*/}

{/*{subCategory0.map((d, i) => {
  const isActive = d.name === activeTab; // Assuming activeTab is the currently active tab name

  return (
    <div key={d.id} className={`border-b ${isActive ? 'border-blue-600' : 'border-gray-200 dark:border-gray-700'}`}>
      <nav
        className="-mb-0.5 flex justify-end space-x-6"
        aria-label="Tabs"
        role="tablist"
      >
        <button
          onClick={() => handleClick(d.name, d.id)}
          type="button"
          className={`
            ${
              isActive
                ? 'font-semibold border-b-2 border-blue-600 text-blue-600'
                : 'text-gray-500 hover:text-blue-600'
            } 
            py-2 px-4 inline-flex items-center gap-2 border-transparent text-sm whitespace-nowrap transition-all duration-300 ease-in-out transform ${
              isActive ? 'scale-105' : ''
            }
          `}
          id={`horizontal-right-alignment-item-${d.id}`}
          data-hs-tab={`#horizontal-right-alignment-${d.id}`}
          aria-controls={`horizontal-right-alignment-${d.id}`}
          role="tab"
        >
           Icon
          {isActive ? (
            <span className={`mr-1 text-lg ${d.icon}`} /> // Active icon
          ) : (

            <span className={`mr-1 text-lg   px-4  text-gray-400 hover:text-blue-600 ${d.icon}`} /> // Inactive icon
          )}
           Tab label
          {d.name}
        </button>

      </nav>
    </div>
  );
})}*/}



      {/* <div className="mt-3">
         <div id="horizontal-right-alignment-1" role="tabpanel" aria-labelledby="horizontal-right-alignment-item-1">
           <p className="text-gray-500 dark:text-gray-400">
             This is the <em className="font-semibold text-gray-800 dark:text-gray-200">first</em> item's tab body.
           </p>
         </div>
         <div id="horizontal-right-alignment-2" className="hidden" role="tabpanel"
              aria-labelledby="horizontal-right-alignment-item-2">
           <p className="text-gray-500 dark:text-gray-400">
             This is the <em className="font-semibold text-gray-800 dark:text-gray-200">second</em> item's tab body.
           </p>
         </div>
         <div id="horizontal-right-alignment-3" className="hidden" role="tabpanel"
              aria-labelledby="horizontal-right-alignment-item-3">
           <p className="text-gray-500 dark:text-gray-400">
             This is the <em className="font-semibold text-gray-800 dark:text-gray-200">third</em> item's tab body.
           </p>
         </div>
       </div>*/}

     </div>





<Category1 subCategory0={subCategory0} subCategory={subCategory} subCategoryName={subCategoryName} subCategoryId={subCategoryId} category={categoryOg} activeTabValue={activeTabValue}/>









   </>
  )
}
